import React from 'react';
import { NavTabs, NavTab } from './Missions.styles';
import { MissionSection } from './missionsData';

interface NavTabsProps {
  sections: MissionSection[];
  activeTab: string;
  onTabClick: (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => void;
}

const NavTabsComponent: React.FC<NavTabsProps> = ({
  sections,
  activeTab,
  onTabClick,
}) => {
  return (
    <NavTabs>
      {sections.map((section) => (
        <NavTab
          key={section.id}
          href={section.id}
          onClick={(e) => onTabClick(e, section.id)}
          $active={activeTab === section.id}
        >
          {section.label}
        </NavTab>
      ))}
    </NavTabs>
  );
};

export default NavTabsComponent;
